export default function DashboardManualIDReview() {
  return (
    <div className='lg:w-full w-11/12 flex flex-col gap-4'>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-4'>
        <p className='font-bold text-2xl text-[#646464]'>What Do I Do Next?</p>
        <p className='font-bold text-[#646464]'>Based on the information provided through your ID.me verification, it appears that your ID may be expired. Our team is currently reviewing your submitted documentation. If we confirm that the ID is expired, we’ll reach out to collect a valid, up-to-date form of identification so we can continue processing your application.</p>
      </div>
    </div>
  )
}
